import React, {useEffect, useState} from "react";
import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn,
    RaikoLabel,
    RaikoLabelType,
    showServerErrorMessage,
    RaikoCardInfoTypeOne,
    RaikoCardInfoTypeOneGridTypeItems,
    RaikoCardInfoTypeOneItemGenerator,
    RaikoCardInfoTypeOneStatusTypes
} from "@moeindal/base-raiko-panel-components";
import {Skeleton} from "@mui/material";
import {MawakibService} from "../../../serverService/mawakibService/MawakibService";
import {css} from "@emotion/css";

export default function MawakibServantRegisterDetail({id, handleCloseDrawer}) {

    const service = new MawakibService()

    useEffect(() => {
        if (id !== -1) {
            getMawakibServantRegisterDetailFromServer()
        }
    }, [id]);


    const [loadingShimmer, setLoadingShimmer] = useState(false);
    const [servantInfo, setServantInfo] = useState({
        "id": 0,
        "firstName": "",
        "lastName": "",
        "nationalCode": "",
        "phoneNumber": "",
        "address": "",
        "jobTitle": "",
        "workplaceAddress": "",
        "workplacePhoneNumber": "",
        "city": {
            "id": 0,
            "name": "",
            "provinceId": 0,
            "provinceName": ""
        },
        "avatar": {
            "downloadUrl": "",
            "streamUrl": "",
        },
        "mawkib": {
            "name": "",
            "referralCode": "",
        },
        "status": "",
        "sendAt": "",
        "lastChangedStatusBy": ""
    })

    function getMawakibServantRegisterDetailFromServer() {
        setLoadingShimmer(true)
        service.getMawakibServantRegisterDetail(id)
            .then(response => {
                setServantInfo(response)
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setLoadingShimmer(false)
        })
    }

    return (
        <div className={css`
            background: white;
            padding: 1rem`}>
            {
                loadingShimmer ?
                    <RaikoGridOneColumn>
                        <Skeleton variant={"rounded"} className={css`padding: 64px`}/>
                    </RaikoGridOneColumn> :
                    <RaikoGridOneColumn>
                        <RaikoFlexFirstChildGrowOne>
                            <RaikoLabel text={"اطلاعات خادم"}
                                        raikoLabelType={RaikoLabelType.TITLE}/>
                            <div className={"ic-close"} onClick={handleCloseDrawer}/>
                        </RaikoFlexFirstChildGrowOne>
                        <RaikoCardInfoTypeOne
                            title={`${servantInfo.firstName} ${servantInfo.lastName}`}
                            titleLabel={servantInfo.nationalCode}
                            status
                            statusText={servantInfo.status === "AWAITING_FOR_REVIEW" ?
                                "در حال بررسی"
                                : servantInfo.status === "ACCEPTED" ?
                                    "پذیرفته شده"
                                    : "رد شده"
                            }
                            statusType={servantInfo.status === "AWAITING_FOR_REVIEW" ?
                                RaikoCardInfoTypeOneStatusTypes.WARNING
                                : servantInfo.status === "ACCEPTED" ?
                                    RaikoCardInfoTypeOneStatusTypes.SUCCESS
                                    : RaikoCardInfoTypeOneStatusTypes.ERROR
                            }
                            items={[
                                RaikoCardInfoTypeOneItemGenerator("شماره همراه", servantInfo.phoneNumber),
                                RaikoCardInfoTypeOneItemGenerator("شهر", servantInfo.city.name),
                                RaikoCardInfoTypeOneItemGenerator("آدرس", servantInfo.address ? servantInfo.address : "-"),
                                RaikoCardInfoTypeOneItemGenerator("شغل", servantInfo.jobTitle ? servantInfo.jobTitle : "-"),
                                RaikoCardInfoTypeOneItemGenerator("شماره محل کار", servantInfo.workplacePhoneNumber ? servantInfo.workplacePhoneNumber : "-"),
                                RaikoCardInfoTypeOneItemGenerator("آدرس محل کار", servantInfo.workplaceAddress ? servantInfo.workplaceAddress : "-"),
                                RaikoCardInfoTypeOneItemGenerator("نام موکب", servantInfo.mawkib ? servantInfo.mawkib.name : "-"),
                                RaikoCardInfoTypeOneItemGenerator("کد معرف", servantInfo.mawkib ? servantInfo.mawkib.referralCode : "-"),
                                RaikoCardInfoTypeOneItemGenerator("تاریخ ثبت", convertUniversalDateTimeToPersianDateTime(servantInfo.sendAt)),
                            ]}
                            gridTypeItems={RaikoCardInfoTypeOneGridTypeItems.FOUR_COLUMN}
                            hasAvatar={true}
                            avatarSource={servantInfo.avatar.downloadUrl}
                        />
                    </RaikoGridOneColumn>
            }
        </div>
    )
}